const TopDestinations = {
  getTopDestinations: (countryId: number) => `/Agency/TopDestinations`,
};

export default TopDestinations;
